var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 56,
    fill: "none",
    xmlnsv: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.594 55.206H2.813C1.259 55.206 0 53.947 0 52.394V13.958c0-1.553 1.259-2.813 2.813-2.813h56.782c1.553 0 2.813 1.259 2.813 2.813v38.436c0 1.553-1.259 2.813-2.812 2.813z",
    fill: "#f9c82b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 52.041v-.546c0-1.802.913-3.481 2.425-4.461l21.223-13.75.29.165L2.425 47.387C.913 48.367 0 50.046 0 51.847v.193zm62.407-.193c0-1.802-.913-3.481-2.425-4.461L38.469 33.449l.29-.165 21.223 13.75c1.512.98 2.425 2.659 2.425 4.461v.353z",
    fill: "#fcde45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.594 55.206H2.813C1.259 55.206 0 53.947 0 52.394v-.353-.193c0-1.802.913-3.481 2.425-4.461l21.513-13.938 4.841 2.76c.738.478 1.581.717 2.425.717s1.687-.239 2.425-.717l4.841-2.76 21.513 13.938c1.512.98 2.425 2.659 2.425 4.461v.546c0 1.553-1.259 2.813-2.812 2.813z",
    fill: "url(#A)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.958v-.049.049z",
    fill: "#fff7ca"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.648 33.284L2.425 21.183C.913 20.203 0 18.524 0 16.722v-2.765-.048h0v.048c0 1.802.913 3.481 2.425 4.461l22.084 14.308-.861.558zm15.111 0l-.861-.558 17.943-11.625c.827.418 1.713.735 2.643.936L38.759 33.284z",
    fill: "#f9c222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.938 33.449l-.29-.165.861-.558.272.177-.844.546zm14.531 0l-.844-.546.272-.177.861.558-.29.165z",
    fill: "#fcd737"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.204 36.926c-.844 0-1.687-.239-2.425-.717l-4.841-2.76.844-.547 3.997 2.59c.738.478 1.581.717 2.425.717s1.687-.239 2.425-.717l3.997-2.59.844.547-4.841 2.76c-.738.478-1.581.717-2.425.717z",
    fill: "url(#B)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.203 36.209c-.844 0-1.687-.239-2.425-.717l-3.997-2.59-.272-.177L2.425 18.418C.913 17.438 0 15.759 0 13.958v-.048c.026-1.531 1.275-2.765 2.812-2.765H49.71 2.813C1.259 11.145 0 12.404 0 13.958l.005.159a2.81 2.81 0 0 1 2.808-2.713h46.901c.097 4.241 2.564 7.898 6.128 9.697L37.898 32.726l-.272.177-3.998 2.59c-.737.478-1.581.717-2.424.717z",
    fill: "url(#C)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M.005 14.117L0 13.958c0-1.553 1.259-2.812 2.813-2.812H49.71l.003.259H2.813a2.81 2.81 0 0 0-2.808 2.713z",
    fill: "url(#D)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72 11.145C72 4.99 67.01 0 60.855 0S49.71 4.99 49.71 11.145 54.7 22.29 60.855 22.29A11.15 11.15 0 0 0 72 11.145z",
    fill: "#fc2a1f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.71 11.126zm0-.019zm0-.019zm0-.02z",
    fill: "#febfbb"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.855 22.29c-.072 0-.144-.001-.216-.002A11.15 11.15 0 0 1 49.71 11.145v-.022-.034-.021c.011-1.607.365-3.131.987-4.508a10.13 10.13 0 0 0-.659 3.6 10.16 10.16 0 0 0 20.319 0A10.16 10.16 0 0 0 60.527.008L60.855 0C67.01 0 72 4.99 72 11.145a11.15 11.15 0 0 1-10.929 11.143l-.216.002z",
    fill: "#fb1f17"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.84 15.983h-1.796V6.506h-1.907V4.931h3.703v11.052z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 31.203,
    y1: 33.262,
    x2: 31.203,
    y2: 67.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6bf20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#f6bf20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#f6ab0e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 31.204,
    y1: 33.262,
    x2: 31.204,
    y2: 67.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6b919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#f6b919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#f6a60b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 31.203,
    y1: 6.22,
    x2: 31.203,
    y2: 38.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    stopColor: "#fff457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#ffdf43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#ffd231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 31.203,
    y1: 6.22,
    x2: 31.203,
    y2: 38.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffd80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    stopColor: "#fffd80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#fff871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#fff563"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSent);
export default __webpack_public_path__ + "static/media/mail-sent.0dfefd03ad326fcb2f5a5d3093af6556.svg";
export { ForwardRef as ReactComponent };